import { validateArguments } from '../../SignatureValidation';
export var BinFn;
(function (BinFn) {
    BinFn.Name = `BIN`;
    BinFn.Stage = "SCALAR";
    BinFn.Signature = `BIN(<expression>, <binSize>)`;
    function make(callName, args, type, role) {
        return {
            name: BinFn.Name,
            stage: BinFn.Stage,
            data: { role, type },
            value: (...values) => {
                if (values.length !== 2) {
                    throw new Error(`BIN function expects 2 arguments but received ${values.length}`);
                }
                const [expression, binSize] = values;
                if (expression === null || binSize === null) {
                    return null;
                }
                if (typeof expression !== 'number' || typeof binSize !== 'number') {
                    throw new Error(`BIN function expects its two arguments to be numbers ` +
                        `but received (${typeof expression}) and (${typeof binSize})`);
                }
                if (binSize <= 0) {
                    throw new Error(`BIN function expects binSize to be greater than zero` +
                        `but received ${binSize}`);
                }
                const binRangeStart = Math.floor(expression / binSize) * binSize;
                return binRangeStart;
            },
        };
    }
    BinFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: {
                name: BinFn.Name,
                signature: BinFn.Signature,
                location: callNode.location,
            },
            arguments: [
                {
                    type: "NUMERIC",
                    stages: ["CONST", "SCALAR"],
                },
                {
                    type: "NUMERIC",
                    stages: ["CONST", "SCALAR"],
                },
            ],
        }, args);
    }
    BinFn.validate = validate;
})(BinFn || (BinFn = {}));
